<template>
    <b-card no-body>
        <b-modal id="reject" :title="['Çıkış İşlemini Reddet',rejectValue.fullName || '*'].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <reject-description v-model="rejectValue"></reject-description>
            <template #modal-footer><v-executer :loading="rejecting" variant="danger" :disabled="!rejectValue.description" :action="reject">Reddet</v-executer></template>
        </b-modal>
        <b-modal id="detail-modal" size="xl" :title="['Personel Çıkış Detayları', (selectedEmployeeDetail ? selectedEmployeeDetail.EmployeeFullName : '')].join(' - ')">
            <SGKExitDetail v-if="!detailLoading" :details="selectedEmployeeDetail" />

            <template #modal-footer>
                <v-executer :loading="approving" variant="success" :action="() => approve(selectedEmployeeDetail)">Onayla</v-executer>
                <v-executer :loading="false" variant="danger" :action="() => openReject(selectedEmployeeDetail)">Reddet</v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    with-items
                    :items="datas"
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SGKExitApi from '@/api/sgk-exit';
import RejectDescription from './components/RejectDescription.vue';
import SGKExitDetail from './components/SGKExitDetail.vue';

export default {
    components:{
        BCard,
        RejectDescription,
        SGKExitDetail 
    },
    data(){
        return {
            fields:[
                {thClass:'w-20',key:'EmployeeFullName',name:'Personel'},
                {thClass:'w-20',key:'ActionDateStr',name:'Hareket Tarihi'},
                {thClass:'w-20',key:'ExitDateStr',name:'Çıkış Tarihi'},
                {thClass:'w-20',key:'CycleIndex',name:'Tekrar Sayısı'},
                {thClass:'w-20',key:'Description',name:'Ret Açıklama'},
            ],
            buttons:[
                { text:"Detay", key:"detail", icon:"EyeIcon", variant:"info", action:this.openDetailModal },
                { text:"Onayla",key:"approve",icon:"CheckCircleIcon",variant:"success",action:this.approve},
                { text:"Reddet",key:"edit",icon:"XCircleIcon",variant:"danger",action:this.openReject},
            ],
            rejectValue:{
                exitTaskId:null,
                description:null,
                fullName:null
            },
            rejecting:false,
            approving:false,
            detailLoading:false,
            selectedEmployeeDetail:null,
            datas:[]
        }
    },
    mounted(){
        this.get()
    },
    methods:{
        openDetailModal(item){
            this.selectedEmployeeDetail = item
            this.detailLoading = true
            this.$showModal('detail-modal')

            SGKExitApi.GetExitTaskInfo(item.EmployeeId).then(res => {
                if(res.data.Success){
                    this.selectedEmployeeDetail = res.data.Data
                    this.selectedEmployeeDetail.SGKJobExitTaskId = item.SGKJobExitTaskId
                    this.selectedEmployeeDetail.EmployeeFullName = item.EmployeeFullName
                }
                else{
                    this.$result(res)
                    this.$hideModal('detail-modal')
                }
                this.detailLoading = false
            }).catch(err => {
                this.$result(null, err)
                this.detailLoading = false
                this.$hideModal('detail-modal')
            })
        },
        get(){
            this.$refs.table.setLoading(true)
            SGKExitApi.MyApprovals().then(res => {
                this.datas = res.data.Data || []
                if(!res.data.Success){
                    this.$result(res)
                }
                this.$refs.table.setLoading(false)
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.setLoading(false)
            })
        },
        openReject(item){
            this.rejectValue.exitTaskId = null
            this.rejectValue.description = null
            this.rejectValue.fullName = null
            this.rejectValue.exitTaskId = item.SGKJobExitTaskId
            this.rejectValue.fullName = item.EmployeeFullName
            this.$showModal('reject')
        },
        approve(item){
            if (!item || !item.SGKJobExitTaskId) return;
            this.approving = true
            if(this.$refs.table) this.$refs.table.rowLoading(true)
            
            SGKExitApi.Approve(item.SGKJobExitTaskId).then(res => {
                if(res.data.Success){
                    this.get()
                    this.$hideModal('detail-modal')
                }
                this.$result(res)
                this.approving = false
                if(this.$refs.table) this.$refs.table.rowLoading(false)
            }).catch(err => {
                this.$result(null,err)
                this.approving = false
                if(this.$refs.table) this.$refs.table.rowLoading(false)
            })
        },
        reject(){
            this.rejecting = true
            SGKExitApi.Reject(this.rejectValue.exitTaskId,this.rejectValue.description).then(res => {
                if(res.data.Success){
                    this.get()
                    this.$hideModal('reject')
                }
                this.$result(res)
                this.rejecting = false
            }).catch(err => {
                this.$result(null,err)
                this.rejecting = false
            })
        },
    }
}
</script>